const fr = {
    login: "Connexion",
    logout: "Déconnexion",
    signIn: "Se connecter",
    signOut: "Se déconnecter",
    profile: "Profil",
    settings: "Paramètres",
    digiAirMenuWaiterLogin: "Connexion serveur DigiAirMenu",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    pinCode: "Code PIN",
    yourAuthenticationFailed: "Échec de l'authentification",
    addToHomeScreen: "Ajouter à l'écran d'accueil",
    installDAM: "Installer DAM",
    language: "Langue",
    chooseLanguage: "Choisir la langue",
    pageNotFound: "Page introuvable",
    backToDashboard: "Retour au tableau de bord",
    currentTable: "Tableau actuel",
    table: "Table",
    tables: "Tables",
    order: "Commande",
    orders: "Commandes",
    option: "Option",
    additive: "Supplément",
    options: "Options",
    additives: "Suppléments",
    empty: "Vide",
    row: "Ligne",
    count: "quantité",
    step: "étape",
    title: "Titre",
    untitledItem: "Sans titre",
    createdAt: "Créé le",
    free: "Gratuit",
    freeItems: "articles gratuits",
    items: "articles",
    item: "article",
    itemsCountOfAll: "{{payCount}} sur {{maxCount}}",
    minimum: "minimum",
    maximum: "maximum",
    all: "Tous",
    unitPrice: "Prix unitaire",
    email: "E-mail",
    print: "Imprimer",
    printingFailed: "Échec de l'impression !",
    orderDetails: "Détails de la commande",
    noOrders: "Aucune commande",
    noOrdersAdded: "Aucune commande ajoutée",
    noAddedItems: "Aucun article ajouté",
    loading: "Chargement",
    createOrSelectOrderAfterSelectingTable: "Sélectionnez d'abord une table puis créez/sélectionnez une commande",
    createOrSelectOrderFirst: "Créez/sélectionnez d'abord une commande",
    customFood: "Article personnalisé",
    customFoods: "Articles personnalisés",
    normalFoodOrDrink: "plat/boisson standard",
    customMenuItems: "Articles personnalisés du menu",
    sentToKitchen: "Envoyé en cuisine",
    sendToKitchen: "Envoyer en cuisine",
    orderDelivered: "Commande livrée",
    selectItemsForSendingToKitchen: "Sélectionnez les articles à envoyer en cuisine",
    type: "type",
    status: "statut",
    description: "description",
    paid: "payé",
    partiallyPaid: "Partiellement payé",
    unpaid: "non payé",
    pending: "En attente",
    canceled: "Annulé",
    created: "Créé",
    accepted: "Accepté",
    completed: "Terminé",
    total: "Total",
    editOrderItem: "Modifier l'article",
    chooseTable: "Choisir une table",
    pickup: "Retrait",
    suspended: "Suspendu",
    processing: "En préparation",
    rejected: "Refusé",
    delivered: "Livré",
    ordersList: "Liste des commandes",
    showOlderOrders: "Afficher les commandes plus anciennes",
    showHistory: "Afficher l'historique",
    showCanceledOrders: "Afficher les commandes annulées",
    showDeliveredOrders: "Afficher les commandes livrées",
    showPaidOrders: "Afficher les commandes payées",
    addNewOrder: "Ajouter une commande",
    ordering: "Prise de commande",
    availableFoods: "Articles disponibles",
    searchByTableName: "Rechercher par table",
    gridView: "Vue grille",
    listView: "Vue liste",
    Filters: "Filtres",
    availableItems: "Articles disponibles",
    searchByFoodName: "Rechercher par nom de plat",
    allCategories: "Toutes les catégories",
    noCategories: "Aucune catégorie",
    addFood: "Ajouter un article",
    editManualItem: "Modifier l'article manuel",
    addManualItem: "Ajouter un article manuel",
    manualItem: "Article manuel",
    manualItems: "Articles manuels",
    sendEmail: "Envoyer l'e-mail",
    send: "Envoyer",
    resendPaymentLink: "Renvoyer le lien de paiement",
    receiverEmail: "E-mail du destinataire",
    receiverPhone: "Téléphone du destinataire",
    emailIsRequired: "L'e-mail est obligatoire",
    phoneNumberIsRequired: "Le numéro de téléphone est obligatoire",
    invalidEmailFormat: "Format d'e-mail invalide",
    iUnderstand: "Je comprends",
    no: "Non",
    yes: "Oui",
    cancel: "Annuler",
    close: "Fermer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    add: "Ajouter",
    preview: "Aperçu",
    changeTable: "Changer de table",
    saveChanges: "Enregistrer les modifications",
    confirm: "Confirmer",
    selectAll: "Tout sélectionner",
    unselectAll: "Tout désélectionner",
    clear: "Effacer",
    accept: "Accepter",
    acceptOrder: "Accepter la commande",
    confirmOrder: "Confirmer la commande",
    rejectOrder: "Refuser la commande",
    pay: "Encaisser",
    payment: "Paiement",
    payments: "Paiements",
    paymentOf: "Paiement de",
    itemsToPay: "Articles à payer",
    price: "Prix",
    basicPrice: "Prix de base",
    totalPrice: "Prix total",
    paidPrice: "Montant payé",
    discount: "Remise",
    discountAmount: "Montant de la remise",
    tipPrice: "Pourboire",
    totalWithTip: "Total avec pourboire",
    amountToPay: "Montant à payer",
    paymentAmount: "Montant du paiement",
    tip: "Pourboire",
    tipAmount: "Montant du pourboire",
    tipCannotBeNegative: "Le montant du pourboire ne peut pas être négatif",
    payByCreditCard: "Payer par carte",
    payInCash: "Payer en espèces",
    checkout: "Encaissement",
    transaction: "Transaction",
    transactionsHistory: "Historique des transactions",
    transactionDetails: "Détails de la transaction",
    paymentType: "Type de paiement",
    paymentStatus: "Statut du paiement",
    totalAmount: "Montant total",
    openPayments: "Paiements ouverts",
    openPaymentsReport: "Rapport des paiements ouverts",
    thisItemPaymentIsAwaitingConfirmation: "Le paiement de cet article est en attente de confirmation",
    yourOrderPaymentIsAwaitingConfirmation: "Cette commande a un paiement en attente de confirmation",
    editableInTime: "Modifiable dans {{minutes}} min {{seconds}} s",
    generalSettings: "Paramètres généraux",
    printMethod: "Méthode d'impression",
    printMethodBrowser: "Boîte de dialogue d'impression du navigateur",
    printMethodBluetooth: "Imprimante Bluetooth",
    printMethodUsb: "Imprimante USB (expérimental)",
    printMethodExternal: "Imprimante / app externe",
    printerSize: "Taille de l'imprimante",
    autoPrint: "Impression automatique",
    virtualKeyboard: "Clavier virtuel",
    delivery: "Livraison",
    deliveryAddress: "Adresse de livraison",
    deliveryDetails: "Détails de livraison",
    addDeliveryDetails: "Ajouter les détails de livraison",
    editDeliveryDetails: "Modifier les détails de livraison",
    createDelivery: "Créer une livraison",
    fullAddress: "Adresse complète",
    postalCode: "Code postal",
    houseNumber: "Numéro",
    doorNumber: "Numéro de porte",
    floor: "Étage",
    fullName: "Nom complet",
    phoneNumber: "Numéro de téléphone",
    deliverySummary: "Résumé de la livraison",
    Error: "Erreur",
    unexpectedErrorOccurred: "Une erreur s'est produite",
    distance: "Distance",
    duration: "Durée",
    minutes: "Minutes",
    deliveryPrice: "Prix de livraison",
    deliveryFee: "Frais de livraison",
    itemsPrice: "Prix des articles",
    totalReceipt: "Total du reçu",
    customer: "Client",
    pickupDetails: "Détails du retrait",
    pickupDate: "Date de retrait",
    pickupTime: "Heure de retrait",
    pickupDatetime: "Date/heure de retrait demandée",
    dropOffTime: "Heure de remise",
    orderTiming: "Horaire de la commande",
    changePickupTime: "Modifier l'heure de retrait",
    pleaseEnterPickupDate: "Veuillez saisir une date de retrait",
    deliveryAndPickupOrders: "Commandes de livraison et de retrait",
    orderId: "ID de commande",
    orderStatus: "Statut de la commande",
    waiter: "Serveur",
    fromCustomerApp: "Depuis l'app client",
    orderType: "Type de commande",
    sendDelivery: "Envoyer la livraison",
    requestCourier: "Demander un livreur",
    callCourier: "Appeler le livreur",
    somethingWentWrong: "Quelque chose s'est mal passé",

    appLogoAlt: "logo digiAirMenu",
    addDAMToHomeScreen: "Ajouter DigiAirMenu à votre écran d'accueil",
    transferToDemo: "Passer en mode démo",
    transferToLive: "Passer en mode réel",
    min: "min",
    max: "max",
    checkoutPrintDataUnavailable: "Les données du reçu de paiement ne sont pas disponibles pour l'impression",
    printUsingExternalDevice: "Imprimer avec un appareil externe",
    orderDeliveredConfirmation: "Êtes-vous sûr que cette commande a été remise ?",
    ItemDetailsAndStatus: "Détails / statut de l'article",
    typeAnythingYouNeed: "Saisissez ce dont vous avez besoin",
    arrival: "Arrivée",
    late_arrival: "Arrivée en retard",
    late_pickup: "Retrait en retard",
    request_new_driver: "Demander un nouveau livreur",
    shipment_destroyed: "Livraison endommagée",
    address_not_found: "Adresse introuvable",
    late_completed: "Terminé en retard",
    isPaid: "Est payé",
    listOfOrders: "Liste des commandes",
    listOfolderOrRejectedOrdersTitle: "Anciennes / refusées",
    Layout: "Disposition",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "Êtes-vous sûr de vouloir convertir la commande <1>{{orderId}}</1> en commande démo ?",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "Êtes-vous sûr de vouloir convertir la commande <1>{{orderId}}</1> en commande réelle ?",
    areYouSureYouWantToSwitchToLiveMode: "Êtes-vous sûr de vouloir passer en mode réel ?",
    areYouSureYouWantToSwitchToDemoMode: "Êtes-vous sûr de vouloir passer en mode démo ?",
    areYouWantDeleteThisItem: "Êtes-vous sûr de vouloir supprimer cet article ?",
    areYouWantCancelOrder: "Êtes-vous sûr de vouloir annuler cette commande ?",
    getEmailLabel: "Veuillez saisir votre e-mail",
    enterValidEmailErr: "Veuillez saisir une adresse e-mail valide.",
    sendReceiptInfo: "Envoyer les détails du reçu",
    sendMenuSms: "Envoyer le lien du menu",
    sendMenuLinkBySms: "Envoyer le lien du menu par SMS",
    menuLinkSentSuccessfully: "Lien du menu envoyé avec succès",
    paymentLinkResentSuccessfully: "Lien de paiement envoyé avec succès",
    receiverEmailPlaceholder: "exemple@email.com",
    emailOrPhoneIsRequired: "L'e-mail ou le numéro de téléphone est obligatoire",
    selected: "sélectionné",
    reset: "Réinitialiser",
    mobileKeyboard: "Clavier mobile",
    externalDeliveryOrder: "Commande de livraison externe",
    externalDeliveryOrderDescription: "Cette commande doit être acceptée avant traitement",
    waiterDraftOrder: "Commande créée par le serveur",
    waiterDraftOrderDescription: "Vous pouvez encore modifier cette commande. Confirmez-la quand tout est finalisé.",
    completeOrderSetup: "Finaliser la commande",
    completeOrderSetupDialogTitle: "Complétez les détails de livraison et finalisez l'horaire de la commande",
    acceptOrderDialogTitle: "Accepter cette commande lancera la préparation et informera la cuisine",
    confirmOrderDialogTitle: "Confirmer cette commande verrouillera les modifications et lancera la préparation",
    acceptOrderExternalDescription: "Cette commande vient d'une source externe. Acceptez-la pour lancer la préparation ou refusez-la si vous ne pouvez pas la traiter.",
    confirmOrderWaiterCreatedDescription: "Cette commande a été créée par un serveur. Vérifiez-la et confirmez-la lorsque tous les articles sont prêts.",
    acceptOrderWaiterCreatedDescription: "Cette commande a été créée par un serveur. Acceptez-la pour verrouiller les modifications et lancer la préparation.",
    editingLockedForCustomerOrder: "La modification est verrouillée pour les commandes client.",
    editingLockedForRejectedOrder: "La modification est verrouillée car cette commande a été refusée.",
    editingLockedCustomerOrderAfterAcceptance: "La modification des commandes client est verrouillée après acceptation.",
    editingLockedAfterConfirmation: "La modification est verrouillée après confirmation de la commande.",
    editingDoneOrderItemLocked: "Les articles déjà terminés ne peuvent plus être modifiés.",
    editingPaidOrderItemLocked: "Les articles payés ne peuvent plus être modifiés.",
    editingPendingPaymentOrderItemLocked: "Cet article ne peut pas être modifié pendant le traitement de son paiement.",
    editingSentToKitchenItemLockedByPermission: "Vous n'avez pas l'autorisation de modifier les articles déjà envoyés en cuisine.",
    rejectOrderConfirm: "Êtes-vous sûr de vouloir refuser cette commande ?",
    acceptOrderPickupTimeHelperText: "Vous pouvez retarder l'heure de retrait jusqu'à <1>30 minutes</1>",
    pleaseEnterPickupTime: "Veuillez saisir une heure de retrait",
    addToOrders: "ajouter aux commandes",
    cancelThisOrder: "Annuler cette commande",
    cancelOrder: "Annuler la commande",
    orderModeChangedToDemoInJSX: "Le mode de commande souhaité est passé en mode démo avec le titre '<1>Commande {{targetOrderId}}</1>'.",
    orderModeChangedToLiveInJSX: "Le mode de commande souhaité est passé en mode réel avec le titre '<1>Commande {{targetOrderId}}</1>'.",
    checkoutHasPaidByPosInJSX: "L'<1>encaissement</1> avec l'id <3>{{checkout_id}}</3> de la <5>commande {{order_id}}</5> a été payé avec succès via POS.",
    demo: "Démo",
    demoModeIsActive: "Le mode démo est actif",
    demoModeAlertMessage: "Le mode démo est destiné exclusivement à la formation et aux tests. L'exploitant du restaurant est seul responsable de l'utilisation du système et du respect de toutes les réglementations légales applicables pendant la durée d'activation du mode démo.",
    normal: "Normal",
    showOrderInTargetMode: "Afficher la commande en mode {{targetMode}}",
    showOrder: "Afficher la commande",
    openOrderInBackground: "<0>Ouvrir</0> <1>(en arrière-plan)</1>",
    incomingOrderNotificationTitle: "Nouvelle commande reçue",
    incomingOrderNotificationDescription: "Une commande client est arrivée. Utilisez le bouton ci-dessous pour l'ouvrir en arrière-plan sans fermer cette fenêtre.",
    yesDeleteIt: "Oui, supprimer",
    payReport: "Rapport de paiement",
    checkoutOperation: "Opération d'encaissement",
    baseAmount: "Montant de base",
    paidBy: "Payé par",
    paymentsIncludingDiscounts: "Paiements avec remises incluses",
    paymentsExcludingDiscounts: "Paiements hors remises",
    paymentsTakingIntoAccountTheirDiscount: "Paiements tenant compte de leur remise",
    paymentsRegardlessOfTheirDiscount: "Paiements sans tenir compte de leur remise",
    openPaymentsStatistics: "Statistiques des paiements ouverts",
    discountCannotBeLessThanZero: 'Le montant de la remise ne peut pas être inférieur à "0"',
    discountCannotBeNegative: "Le montant de la remise ne peut pas être négatif",
    discountCannotBeMoreThanHundredPercent: 'Le montant de la remise ne peut pas dépasser "100%"',
    discountCannotBeMoreThan: "Le montant de la remise ne peut pas dépasser {{price}}",
    theValueMustBeMoreThan: "La valeur doit être supérieure à {{price}}",
    theValueMustBeMoreThanBaseAmount: "La valeur doit être supérieure au montant de base",
    valueMustBeLessThanOrEqualToMessage: "La valeur doit être inférieure ou égale à {{maxPrice}}",
    valueMustBeGreaterThanZeroMessage: "La valeur doit être supérieure à 0",
    cardTransfer: "Virement par carte",
    noTransactionHasBeenMade: "Aucune transaction n'a été effectuée",
    backToTransactionsList: "Retour à la liste des transactions",
    transactionId: "ID de transaction",
    transactionHasBeenSentToYourEmail: "La transaction a été envoyée à votre e-mail",
    ordersPrice: "Montant des commandes",
    updatedAt: "Mis à jour le",
    fromTime: "De",
    toTime: "À",
    backToOrders: "Retour aux commandes",
    tablesList: "Liste des tables",
    backToTablesList: "Retour à la liste des tables",
    showDetails: "Afficher les détails",
    receiptDetailsPage: "Page des détails du reçu",
    checkoutQrCodeAlt: "Code QR d'encaissement",
    vat: "TVA",
    net: "Net",
    tax: "Taxe",
    gross: "Brut",
    sendingEmailFailed: "Échec de l'envoi de l'e-mail !",
    paymentFailed: "Échec du paiement",
    Open_Payments: "Paiements ouverts",
    report: "Rapport",
    openPaymentStatistics: "Statistiques du paiement ouvert",
    allOrderItemsHaveBeenPaid: "Tous les articles de cette commande ont été payés",
    noItemsHaveBeenAddedInThisOrder: "Aucun article n'a été ajouté à cette commande",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Cet article a été payé via POS et attend la confirmation du paiement",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Votre commande a été payée via POS et attend la confirmation du paiement",
    customItems: "Articles personnalisés",
    singlePrintMethodDescription: "Une seule méthode d'impression est active à la fois",
    bluetoothUnavailable: "Bluetooth n'est pas disponible sur ce navigateur ou cet appareil",
    bluetoothSecureContextRequired: "L'impression Bluetooth nécessite HTTPS ou localhost",
    bluetoothPrinterNotSupported: "L'imprimante Bluetooth sélectionnée n'est pas prise en charge",
    noBluetoothPrinterSelected: "Aucune imprimante Bluetooth n'a été sélectionnée",
    noCompatibleBluetoothPrinterFound: "Aucune imprimante Bluetooth compatible n'a été trouvée ou sélectionnée. Les navigateurs détectent généralement seulement les imprimantes BLE/GATT, donc les modèles Bluetooth classiques comme Epson TM-m30 peuvent ne pas apparaître ici",
    bluetoothAutoPrintRequiresSelection: "Sélectionnez manuellement une imprimante Bluetooth une fois avant d'utiliser l'impression automatique",
    bluetoothPrintingNotSupported: "L'impression Bluetooth n'est pas prise en charge sur ce navigateur ou cet appareil",
    usbUnavailable: "USB n'est pas disponible sur ce navigateur ou cet appareil",
    usbSecureContextRequired: "L'impression USB nécessite HTTPS ou localhost",
    noCompatibleUsbPrinterFound: "Aucune imprimante USB compatible n'a été trouvée ou sélectionnée",
    usbAccessDenied: "Le navigateur ou le système d'exploitation a refusé l'accès à l'imprimante USB sélectionnée. Fermez les autres applications d'impression et vérifiez les autorisations USB du système, puis réessayez",
    usbAutoPrintRequiresSelection: "Sélectionnez manuellement une imprimante USB une fois avant d'utiliser l'impression automatique",
    usbPrintingNotSupported: "L'impression USB n'est pas prise en charge pour l'appareil sélectionné",
    useExternalPrinter: "Utiliser une imprimante externe",
    bluetoothPrinterDetails: "Vous pouvez envoyer l'impression à des imprimantes Bluetooth ou désactiver cette option pour choisir une imprimante connectée à cet appareil",
    usbPrinterDetails: "Prise en charge expérimentale des imprimantes USB compatibles ESC/POS sur Chrome ou Edge de bureau. Vous devrez peut-être sélectionner l'imprimante manuellement une fois avant que l'impression automatique puisse l'utiliser. Sous Windows, l'imprimante peut aussi nécessiter le mode Vendor Class et un pilote compatible WinUSB pour apparaître dans la liste du navigateur",
    externalPrinterDetails: "Vous pouvez envoyer l'impression à des imprimantes externes connectées à l'application ou désactiver cette option pour choisir une imprimante connectée à cet appareil",
    autoPrintDescription: "Imprimer automatiquement après acceptation d'une commande ou après réception d'un événement websocket de commande payée",
    autoPrintUnavailableForBrowserDescription: "L'impression automatique n'est pas disponible avec la boîte de dialogue d'impression du navigateur",
    browserPrintMethodNotice: "La boîte de dialogue d'impression du navigateur nécessite toujours une confirmation, les reçus ne peuvent donc pas être imprimés automatiquement",
    selectAllPayablesByDefault: "Sélectionner tous les éléments payables par défaut",
    selectAllPayablesByDefaultOnThePaymentPage: "Sélectionner par défaut tous les éléments payables sur la page de paiement",
    virtualKeyboardDescription: "Utiliser le clavier intégré de l'application dans les champs pris en charge",
    virtualKeyboardInfoLabel: "Aide clavier",
    virtualKeyboardDisableHint: "Si vous préférez le clavier de votre appareil, vous pouvez désactiver ce clavier dans <0>Paramètres</0>.",
    served: "Servi",
    apartmentEntrance: "Entrée de l'appartement",
    extraAddressDetails: "Détails supplémentaires de l'adresse",
    dialCode: "Indicatif",
    contactInformationAtPickup: "Coordonnées du destinataire",
    recommended: "recommandé",
    successfulDeliveryRegistration: "Livraison enregistrée avec succès",
    successfulSendDelivery: "Livraison envoyée avec succès",
    withDelivery: "Avec livraison",
    deliveryItem: "Article de livraison",
    pickupTimeLabel: "Heure de retrait ({{format}})",
    pickupTimeBaseLabel: "Heure de retrait de base",
    pickupTimeFinalLabel: "Heure de retrait finale",
    requestedPickupDatetime: "Date/heure de retrait actuellement demandée",
    timePickerHour: "Heure",
    timePickerMinute: "Minute",
    toggleTimeList: "Afficher/masquer la liste des heures",
    pickupTimeInitialShort: "Base",
    maximumSelectableFreeCountHint: "Nombre maximal sélectionnable gratuitement",
    minimumSelectableCountHint: "Nombre minimal sélectionnable",
    maximumSelectableCountHint: "Nombre maximal sélectionnable",
    maximumSelectedItemsReached: "Le nombre maximal d'articles sélectionnés est atteint",
    pickupTimeAllowedRangeHint: "Pour {{date}}, l'heure de retrait peut être choisie de {{start}} à {{end}}.",
    pickupDatetimeNotSetHint: "Aucune date/heure de retrait n'a encore été définie. Vous pouvez choisir n'importe quelle heure de retrait.",
    pickupDatetimeLimitedDelayHint: "Cette date/heure de retrait demandée peut être retardée jusqu'à <1>30 minutes</1> tant que la commande est en attente d'acceptation.",
    pickupDatetimeLockedHint: "Une date/heure de retrait est déjà définie pour cette commande.",
    pickupTimeEditableOnlyWhenSuspended: "L'heure de retrait ne peut être modifiée que lorsque la commande est suspendue.",
    pickupDateMustBeTodayOrTomorrow: "La date de retrait doit être aujourd'hui ou demain pour les commandes créées par le serveur.",
    normalOrderCreationUnavailableTitle: "Les commandes normales sont actuellement indisponibles",
    normalOrderCreationClosedAllDay: "Le restaurant est fermé ce jour-là, les commandes ne peuvent donc pas être créées.",
    normalOrderCreationClosedAtThisTime: "Le restaurant est actuellement fermé. Les commandes peuvent être créées pendant les heures d'ouverture : {{hours}}.",
    waiterOrderNoAvailableOpenSlot: "Aucun créneau {{orderType}} valide n'est disponible dans les heures d'ouverture du restaurant pour les dates actuellement autorisées.",
    pickupDateOutsideOpeningHours: "La date sélectionnée est hors des jours d'ouverture autorisés pour les commandes {{orderType}}.",
    pickupTimeOutsideOpeningHours: "L'heure sélectionnée est hors des heures autorisées pour les commandes {{orderType}}.",
    openingHoursSelectableRangeHint: "Pour {{date}}, l'heure de {{orderType}} peut être choisie de {{start}} à {{end}}.",
    openingHoursClosedDayHint: "{{date}} est fermé pour les commandes {{orderType}}.",
    openingHoursClosedDayCalendarHint: "Fermé pour ce type de commande",
    openingHoursDisabledDatesHint: "Seules les dates avec au moins une heure {{orderType}} disponible pendant les heures d'ouverture du restaurant peuvent être choisies.",
    openingHoursUnavailableTimesHint: "Les heures non sélectionnables sont hors des heures d'ouverture du restaurant pour les commandes {{orderType}} à la date choisie.",
    payByLink: "Payer par lien",
    updateDelivery: "Mettre à jour la livraison",
    sendCourierRequest: "Envoyer la demande de livreur",
    sentToCourier: "Envoyé au livreur",
    noPickupTimeProvidedForThisOrder: "Aucune heure de retrait n'a été fournie pour cette commande",
    pickupTimeCalculationForThisOrderFailed: "Le calcul de l'heure de retrait a échoué pour cette commande",
    itemEditFailed: "La modification de l'article a échoué",
    thisItemCannotBeEdited: "Cet article ne peut pas être modifié.",
    problemInReadingItemEssentialDataMessage: "Un problème est survenu lors de la lecture des informations essentielles de l'article",
};

export default fr;
